<template>
    <div id="user-detail">
        <!-- begin breadcrumb -->
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'User Management', to: { path: '/user-management' } },
                { text: 'Informasi User' },
            ]"
            divider="|"
        ></v-breadcrumbs>
        <!-- end breadcrumb -->
        <!-- begin page-header -->
        <h3 class="header-text font-weight-bold">Informasi User</h3>
        <!-- end page-header -->

        <v-layout class="pt-0 px-0 pb-3 mb">
            <!-- Detail Tab Button to show detail user -->
            <v-btn
                id="user-detail-btn"
                class="mr-2"
                :class="tab == 3 ? 'darkFade--text' : 'white--text'"
                :color="tab == 3 ? 'white' : 'blew'"
                elevation="0"
                @click="tab = 1"
                >Detail</v-btn
            >

            <!-- Riwayat Tryout Tab Button to show user tryout history -->
            <v-btn
                id="user-history-tryout-btn"
                :class="tab == 3 ? 'white--text' : 'darkFade--text'"
                :color="tab == 3 ? 'blew' : 'white'"
                class="mr-2"
                elevation="0"
                @click="tab = 3"
                >Riwayat Tryout</v-btn
            >
        </v-layout>
        <!-- isUpdate used for checking for permission  -->
        <div v-if="isUpdate">
            <!-- Detail User Preview -->
            <v-card v-show="tab == 1">
                <v-card-title>
                    Detail User
                    <v-spacer></v-spacer>
                    <!-- Update Tab Button -->
                    <v-btn
                        id="user-update-btn"
                        elevation="0"
                        color="white"
                        class="blew--text"
                        @click="updateData"
                        ><v-icon style="font-size: 16px !important"
                            >mdi-pencil</v-icon
                        >
                        Ubah Data
                    </v-btn>
                </v-card-title>
                <v-divider />
                <v-card flat class="d-flex pb-3">
                    <v-col cols="3" class="py-0">
                        <v-card flat>
                            <!-- Image user preview -->
                            <v-card-text>
                                <v-card
                                    flat
                                    class="border-bottom-divider rounded-tl px-2"
                                >
                                    <a href="javascript:;">
                                        <v-img
                                            aspect-ratio="1"
                                            :src="$store.state.usman.picture"
                                        />
                                    </a>
                                </v-card>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col
                        cols="9"
                        class="px-0"
                        style="border-left: 1px solid #f0f0f0"
                    >
                        <v-card flat>
                            <!-- User items list -->
                            <v-card-text class="pa-0">
                                <v-list-item>
                                    <v-list-item-title class="font-weight-bold">
                                        Nama Siswa
                                    </v-list-item-title>
                                    <div>
                                        {{
                                            $store.state.usman.name.toUpperCase()
                                        }}
                                    </div>
                                </v-list-item>
                                <v-list-item style="background-color: #fbfbfb">
                                    <v-list-item-title class="font-weight-bold">
                                        No Siswa
                                    </v-list-item-title>
                                    <div>
                                        {{ $store.state.usman.student_number }}
                                    </div>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-bold">
                                        Email
                                    </v-list-item-title>
                                    <div>
                                        {{ $store.state.usman.email }}
                                    </div>
                                </v-list-item>
                                <v-list-item style="background-color: #fbfbfb">
                                    <v-list-item-title class="font-weight-bold">
                                        No.Telpon
                                    </v-list-item-title>
                                    <div>
                                        {{ $store.state.usman.phone_number }}
                                    </div>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-bold">
                                        Sekolah
                                    </v-list-item-title>
                                    <div>
                                        {{
                                            $store.state.usman.school
                                                ? $store.state.usman.school.toUpperCase()
                                                : ""
                                        }}
                                    </div>
                                </v-list-item>
                                <v-list-item style="background-color: #fbfbfb">
                                    <v-list-item-title class="font-weight-bold">
                                        Kelas
                                    </v-list-item-title>
                                    <div>
                                        {{ $store.state.usman.grade }}
                                    </div>
                                </v-list-item>
                                <v-list-item
                                    v-if="$store.state.usman.group_schedule"
                                >
                                    <v-list-item-title class="font-weight-bold">
                                        Group
                                    </v-list-item-title>
                                    <div>
                                        {{
                                            data.group_schedule
                                                ? data.group_schedule
                                                : "-"
                                        }}
                                    </div>
                                </v-list-item>
                                <v-list-item
                                    :style="
                                        $store.state.usman.group_schedule
                                            ? 'background-color: #fbfbfb'
                                            : ''
                                    "
                                >
                                    <v-list-item-title class="font-weight-bold">
                                        Status
                                    </v-list-item-title>
                                    <div v-if="isActive">
                                        Aktif sampai:
                                        {{ $store.state.usman.expired_at }}
                                    </div>
                                    <div
                                        v-else
                                        class="burgundy--text font-weight-bold"
                                    >
                                        Inactive
                                    </div>
                                </v-list-item>
                                <!-- isUpdate used for checking for permission  -->
                                <v-list-item v-if="isUpdate">
                                    <v-list-item-title class="font-weight-bold">
                                        User Scope
                                    </v-list-item-title>
                                    <div style="width: 100%">
                                        <v-btn
                                            rounded
                                            depressed
                                            disabled
                                            class="mb-2 mr-2"
                                            v-for="(
                                                scope, index
                                            ) in detail.user_app_scopes"
                                            :key="index"
                                        >
                                            {{ scope.app_scope_id.name }}
                                        </v-btn>
                                        <!-- <table width="100%" class="mt-3">
                      <thead>
                        <tr>
                          <td width="30%">Scope Name</td>
                          <td width="30%">Description</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(scope, index) in detail.user_app_scopes">
                          <td class="pt-3">
                            <v-btn rounded depressed disabled>
                              {{ scope.app_scope_id.name }}
                            </v-btn>
                          </td>
                          <td style="font-size: 12px">
                            {{ scope.app_scope_id.displayName }}
                          </td>
                        </tr>
                      </tbody>
                    </table> -->
                                        <!-- <v-btn
                      color="fade"
                      class="black--text mr-2 mb-2"
                      v-for="(scope, i) in $store.state.usman.user_app_scopes"
                      :key="i"
                      disabled
                      rounded
                    >
                      {{ scope }}
                    </v-btn> -->
                                    </div>
                                </v-list-item>
                                <!-- Activation User Premium field -->
                                <!-- <v-list-item v-if="!isActive">
                  <v-list-item-title class="font-weight-bold">
                    Aktivasi User
                  </v-list-item-title>
                </v-list-item>
                <v-container v-if="!isActive">
                  <v-row class="pb-0">
                    <v-col cols="6">
                      <v-text-field
                        id="user-email-sip"
                        v-model="emailSIP"
                        placeholder="Email SIP"
                        :dense="$vuetify.breakpoint.smAndDown"
                        outlined
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        id="user-nomor-induk-nf"
                        v-model="nomorIndukNF"
                        placeholder="No.Induk NF, 123-45-67890"
                        :dense="$vuetify.breakpoint.smAndDown"
                        outlined
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">
                      <v-btn
                        id="user-activation-btn"
                        block
                        class="font-weight-bold dark--text"
                        color="white"
                        @click="activateUser()"
                        >Aktivasi Siswa</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container> -->
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-card>
            </v-card>

            <!-- Detail Update User -->

            <!-- Tryout History User -->
            <div v-show="tab == 3">
                <v-card
                    v-for="(membership, key) in memberships"
                    v-bind:key="key"
                    style="
                        background: #ffffff;
                        box-shadow: 0px 0px 10px rgba(51, 46, 101, 0.08);
                        border-radius: 4px;
                    "
                    class="pa-2 mb-2"
                >
                    <v-card-title
                        class="text-subtitle-1 font-weight-bold darkBlue--text"
                    >
                        {{ membership.name }}
                    </v-card-title>
                    <v-card-subtitle>
                        ({{ displayTimestamp(membership.opened_at) }} -
                        {{ displayTimestamp(membership.closed_at) }})
                    </v-card-subtitle>

                    <v-card-text>
                        <v-card outlined color="#FBFBFB">
                            <v-card-text>
                                <!-- Tryout list -->
                                <table style="width: 100%; table-layout: fixed">
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                Nama Tryout
                                            </th>
                                            <th class="text-left">Status</th>
                                            <th class="text-left">
                                                Pengerjaan (m)
                                            </th>
                                            <th class="text-left">Soal</th>
                                            <th class="text-left">Benar</th>
                                            <th class="text-left">Salah</th>
                                            <th class="text-left">Kosong</th>
                                            <th class="text-left"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                tryout, key
                                            ) in membership.tryouts"
                                            v-bind:key="key"
                                            class="font-weight-700"
                                        >
                                            <td class="text-left">
                                                {{ tryout.name }}
                                            </td>
                                            <td class="text-left">
                                                <div
                                                    class="tryout-state blew--text"
                                                    v-if="
                                                        tryout.state ===
                                                        'JOINED'
                                                    "
                                                >
                                                    Bergabung
                                                </div>
                                                <div
                                                    class="tryout-state warning--text"
                                                    v-if="
                                                        tryout.state ===
                                                        'STARTED'
                                                    "
                                                >
                                                    Mengerjakan
                                                    <span
                                                        >({{
                                                            displayTimestamp(
                                                                tryout.started_at,
                                                            )
                                                        }})</span
                                                    >
                                                </div>
                                                <div
                                                    class="tryout-state warning--text"
                                                    v-if="
                                                        tryout.state ===
                                                        'FINISHED'
                                                    "
                                                >
                                                    Mengumpulkan
                                                    <span
                                                        >({{
                                                            displayTimestamp(
                                                                tryout.completed_at,
                                                            )
                                                        }})</span
                                                    >
                                                </div>
                                                <div
                                                    class="tryout-state success--text"
                                                    v-if="
                                                        tryout.state ===
                                                        'GRADED'
                                                    "
                                                >
                                                    Dinilai
                                                </div>
                                            </td>
                                            <td class="text-left">
                                                {{
                                                    tryout.completion_time
                                                        ? Math.ceil(
                                                              tryout.completion_time /
                                                                  60,
                                                          )
                                                        : "-"
                                                }}
                                            </td>
                                            <td class="text-left">
                                                {{ getItemCount(tryout) }}
                                            </td>
                                            <td class="text-left">
                                                {{ tryout.correct }}
                                            </td>
                                            <td class="text-left">
                                                {{ tryout.wrong }}
                                            </td>
                                            <td class="text-left">
                                                {{ tryout.empty }}
                                            </td>
                                            <th class="text-right">
                                                <v-btn
                                                    id="user-reset-tryout-btn"
                                                    plain
                                                    :disabled="
                                                        tryout.state ===
                                                        'JOINED'
                                                    "
                                                    class="redLight--text"
                                                    @click="
                                                        dialogConfirm.open = true;
                                                        dialogConfirm.bundle_code =
                                                            tryout.bundle_code;
                                                        dialogConfirm.email =
                                                            $store.state.usman.email;
                                                    "
                                                    >Reset</v-btn
                                                >
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </div>
        </div>

        <!-- Confirmation to reset status tryout user to Bergabung -->
        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    Yakin ingin mengembalikan status ?
                </v-card-title>
                <v-card-text>
                    Status pengerjaan try out ini akan menjadi Bergabung.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        id="user-cancel-reset-btn"
                        color="darkFade"
                        text
                        @click="
                            dialogConfirm.open = false;
                            dialogConfirm.bundle_code = null;
                            dialogConfirm.email = null;
                        "
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        id="user-OK-btn"
                        color="blew"
                        text
                        @click="
                            resetState(
                                dialogConfirm.bundle_code,
                                dialogConfirm.email,
                            );
                            dialogConfirm.open = false;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AccountService from "@/modules/auth/services/auth.js";
import axios from "axios";
import moment from "moment";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "user-detail",

    components: {
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            tab: 1,
            memberships: [],
            emailSIP: null,
            nomorIndukNF: null,
            isLoading: false,
            queryId: null,
            data: {
                name: null,
                student_number: null,
                email: null,
                phone_number: null,
                school: null,
                grade: null,
                group_schedule: null,
                class: null,
                expired_at: null,
                deactivate: null,
                app_scope: [],
                scope_choose: [],
                user_scopes_expired: [],
            },
            detail: {},
            scopes: [],
            dialogConfirm: {
                open: false,
                bundle_code: null,
                email: null,
            },
        };
    },

    computed: {
        // Check expiredAt User Premium has not passed
        isActive: function () {
            var now = new moment();
            var expiredAt = new moment(
                this.$store.state.usman.expired_at,
                "YYYY-MM-DD",
            );
            var diff = expiredAt.valueOf() - now.valueOf();
            if (diff > 0) {
                this.data.deactivate = 0;
                return true;
            } else {
                return false;
            }
        },
    },

    methods: {
        // Get all list data user scope
        getDataDetail: function () {
            var context = this;
            var token = this.$ls.get("token");
            var user_id = this.$store.state.usman.user_id;

            var url =
                process.env.API_BASE_URL + `account/usman/${user_id}/user`;

            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url)
                .then(function (response) {
                    context.detail = response.data;
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        getScopeList: function () {
            var context = this;
            var token = this.$ls.get("token");
            var url = process.env.API_BASE_URL + "account/appscopes/getlist";

            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url)
                .then(function (response) {
                    context.scopes = _.orderBy(
                        response.data,
                        ["name"],
                        ["asc"],
                    );
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        // Joining data Detail User Management with data Jadwal Kelas by group_schedule
        getJadwalKelas: function () {
            if (!this.data.group_schedule) {
                return false;
            }
            if (this.data.class) {
                return true;
            }

            var context = this;
            var token = this.$ls.get("token");
            var url =
                process.env.API_BASE_URL +
                "payment/package/group/" +
                this.data.group_schedule +
                "/detail";

            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url)
                .then(function (response) {
                    context.data.class = response.data;
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        // Get User Detail data
        loadDetailData: function () {
            // check membership
            var context = this;
            var token = this.$ls.get("token");
            if (!this.$store.state.usman.user_id)
                this.$router.replace({ name: "UserManagement" });
            var url = process.env.API_BASE_URL + "/tryout-service/membership";

            this.isLoading = true;
            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url, {
                params: {
                    email: context.$store.state.usman.email,
                },
            })
                .then(function (response) {
                    context.memberships = response.data;
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        // Change expired_at to todays date for forced deactive premium
        deactivate: function () {
            if (this.data.deactivate == 0) {
                const today = new Date();
                const date = moment().format("YYYY-MM-DD");
                this.data.expired_at = date;
                this.data.deactivate = 1;
            } else {
                this.data.deactivate = 0;
            }
        },

        // Change Date Format from millisecond
        displayTimestamp: function (timeInMilis) {
            if (!timeInMilis) return "-";
            return moment(timeInMilis).format("D MMM YYYY HH:mm");
        },

        updateData() {
            this.$router.push("/user-form");
        },

        getItemCount: function (tryout) {
            var total = 0;
            tryout.subtests.forEach(function (subtest) {
                total += subtest.item_count;
            });

            return total;
        },

        // Activation User Premium
        activateUser: function () {
            var userId = this.$store.state.usman.user_id;
            var cleanString = this.nomorIndukNF.replace(/-/g, "");
            var formattedNoInduk = this.nomorIndukNF;

            if (cleanString.length === 10) {
                formattedNoInduk =
                    cleanString.substring(0, 3) +
                    "-" +
                    cleanString.substring(3, 5) +
                    "-" +
                    cleanString.substring(5);
            }

            this.isLoading = true;
            var context = this;
            AccountService.userActivation(
                userId,
                this.emailSIP,
                formattedNoInduk,
                function (response) {
                    if (response.success) {
                        var userData = response.data;
                        context.$store.commit("usman_init", userData);
                        context.data.user_id =
                            context.$store.state.usman.user_id;
                        context.data.picture =
                            context.$store.state.usman.picture;
                        context.data.name = response.data.name;
                        context.data.student_number =
                            response.data.student_number;
                        context.data.email = response.data.email;
                        context.data.phone_number = response.data.phone_number;
                        context.data.school = response.data.school;
                        context.data.grade = response.data.grade;
                        context.data.expired_at = response.data.expired_at;
                        context.data.user_app_scopes =
                            response.data.user_app_scopes;
                        context.data.user_scopes_expired =
                            response.data.user_scopes_expired;

                        context.$store.commit("showAlert", {
                            message: `Aktivasi user telah berhasil!`,
                            type: "success",
                        });
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal melakukan aktivasi user!`,
                            type: "error",
                        });
                    }

                    context.isLoading = false;
                },
            );
        },

        // Reset tryout status that choosen
        resetState: function (bundle_code, email) {
            var body = {
                bundle_code: bundle_code,
                email: email,
            };

            var context = this;
            TryoutService.resetStateTryout(body, function (result) {
                if (result.success) {
                    context.loadDetailData();
                    context.$store.commit("showAlert", {
                        message: `Berhasil mereset status!`,
                        type: "success",
                    });
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal mereset status!`,
                        type: "error",
                    });
                }
            });
        },

        // Update User
        editData: function () {
            if (this.data.name == "") {
                this.$store.commit("showAlert", {
                    message: `Nama wajib diisi!`,
                    type: "error",
                });
                return true;
            }

            var context = this;
            var userId = this.$store.state.usman.user_id;
            var token = this.$ls.get("token");
            var url =
                process.env.API_BASE_URL +
                "account/usman/admin/update/" +
                userId +
                "/users";

            this.isLoading = true;
            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            var param = {};
            param.student_name = this.data.name;
            param.student_number =
                this.data.student_number == ""
                    ? null
                    : this.data.student_number;
            param.phone_number = this.data.phone_number;
            param.student_school = this.data.school;
            param.grade = this.data.grade;
            param.deactivate = this.data.deactivate;
            param.expired_at = Math.round(
                new Date(this.data.expired_at).getTime(),
            );
            param.user_app_scopes = this.data.app_scope;
            param.user_scopes_expired = this.data.user_scopes_expired;
            http.put(url, param)
                .then(function (response) {
                    context.data.user_id = context.$store.state.usman.user_id;
                    context.data.picture = context.$store.state.usman.picture;
                    context.data.name = response.data.name;
                    context.data.student_number = response.data.student_number;
                    context.data.email = response.data.email;
                    context.data.phone_number = response.data.phone_number;
                    context.data.school = response.data.school;
                    context.data.grade = response.data.grade;
                    context.data.expired_at = response.data.expired_at;
                    context.data.user_app_scopes =
                        response.data.user_app_scopes;
                    context.data.user_scopes_expired =
                        response.data.user_scopes_expired;

                    context.$store.commit("usman_init", context.data);
                    context.$router.push("user-detail");
                    context.$store.commit("showAlert", {
                        message: `Update data user telah berhasil!`,
                        type: "success",
                    });
                })
                .catch(function (error) {
                    context.$store.commit("showAlert", {
                        message: `Error!`,
                        submessage: error.message,
                        type: "error",
                    });
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        // Check admin permission and load user data choosen
        isUpdate: function () {
            let answer = false;
            const token = JSON.parse(localStorage.token).value;
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split("")
                    .map(
                        (c) =>
                            `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`,
                    )
                    .join(""),
            );

            const decoded = JSON.parse(jsonPayload);
            for (let scope in decoded.user_scopes) {
                if (
                    decoded.user_scopes[scope] === "write_userman" ||
                    decoded.user_scopes[scope] === "write_appscope"
                ) {
                    answer = true;
                    this.data.name = this.$store.state.usman.name;
                    this.data.student_number =
                        this.$store.state.usman.student_number == "-"
                            ? null
                            : this.$store.state.usman.student_number;
                    this.data.email = this.$store.state.usman.email;
                    this.data.phone_number =
                        this.$store.state.usman.phone_number;
                    this.data.school = this.$store.state.usman.school;
                    this.data.grade = this.$store.state.usman.grade;
                    this.data.expired_at = this.$store.state.usman.expired_at;
                    // this.data.app_scope = this.$store.state.usman.user_app_scopes;
                    this.data.user_scopes_expired =
                        this.$store.state.usman.user_scopes_expired;
                    this.data.group_schedule =
                        this.$store.state.usman.group_schedule;
                    this.data.group_schedule =
                        this.$store.state.usman.group_schedule;
                    var now = new moment();
                    var expiredAt = new moment(
                        this.$store.state.usman.expired_at,
                        "YYYY-MM-DD",
                    );
                    var diff = expiredAt.valueOf() - now.valueOf();
                    if (diff > 0) {
                        this.data.deactivate = 0;
                    } else {
                        this.data.deactivate = 1;
                    }

                    var data_scopes = this.$store.state.usman.user_app_scopes;
                    this.data.app_scope = [];
                    data_scopes.map((res) => {
                        this.data.app_scope.push(res.app_scope_id.id);
                    });

                    this.getJadwalKelas();
                }
            }
            return answer;
        },
    },

    mounted: function () {
        this.getDataDetail();
        this.loadDetailData();
        this.getScopeList();
        this.isUpdate();
    },
};
</script>

<style scoped>
.text-subtitle-1 {
    font-family: Roboto !important;
}
</style>



// WEBPACK FOOTER //
// UserManagementDetail.vue?2cce6373